module.exports = __webpack_public_path__ + "img/thumbnail_SlothBear_j_albino.d89aa2c9.png";